module.exports = __webpack_public_path__ + "static/media/enterprise2.9bea5c38.png";